<template>
  <div>
    <div v-if="isBootstrapping" v-loading="true" style="--el-loading-spinner-color: #004879;"class="bootstrap-loading">
      <div class="loading-spinner"></div>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { bootstrapAuth } from './utils/bootstrap'
import { isEmbedMode } from './utils/embedMode'
import { Userpilot } from 'userpilot'

export default {
  name: 'App',
  data() {
    return {
      isBootstrapping: true
    };
  },
  async created() {
    try {
      await bootstrapAuth(this.$store);
    } catch (error) {
      console.error('❌ Bootstrap failed:', error);
    } finally {
      this.isBootstrapping = false;
      this.addCustomerIdToFullStory()
      this.addCustomerIdToUserPilot()
      this.notifyParentReady()
    }
  },
  methods: {
    addCustomerIdToFullStory() {
      window.FS('start')
      let userInfo = this.$store.state.login?.userInfo;
      if (!userInfo) {
        const userInfoStr = sessionStorage.getItem('userInfo');
        try {
          userInfo = userInfoStr ? JSON.parse(userInfoStr) : null;
        } catch (e) {
          console.warn('Failed to parse userInfo from sessionStorage:', e);
        }
      }
      if (userInfo) {
        let internalUserId = userInfo.internal_user_id ? `_${userInfo.internal_user_id}` : ''
        let userType = userInfo.internal_user_id ? 'internal_' : 'client_'
        window.FS('setIdentity', {
          uid: userInfo.customer_id.toString(),
          properties: {
            displayName: userType + userInfo.customer_id + '_' + userInfo.clinic_id + internalUserId
          }
        })
      }
    },

    // Signal the va-portal parent that bootstrap finished and the app is
    // ready to interact with. va-portal uses this to hide its iframe loading
    // overlay. No-op when not embedded.
    notifyParentReady() {
      try {
        if (!isEmbedMode()) return;
        if (typeof window === 'undefined') return;
        if (!window.parent || window.parent === window) return;
        window.parent.postMessage(
          { type: 'va-portal:embed-ready', source: 'ehr-frontend' },
          '*'
        );
      } catch (err) {
        console.warn('embed-ready postMessage failed', err);
      }
    },

    addCustomerIdToUserPilot() {
      // Check if Userpilot is loaded (silently skip if not available)
      if (typeof window.userpilot === 'undefined') {
        console.log('Userpilot is not loaded');
        return;
      }
      
      let userInfo = this.$store.state.login?.userInfo;
      if (!userInfo) {
        const userInfoStr = sessionStorage.getItem('userInfo');
        try {
          userInfo = userInfoStr ? JSON.parse(userInfoStr) : null;
        } catch (e) {
          console.warn('Failed to parse userInfo from sessionStorage:', e);
        }
      }
      if (userInfo) {
        window.userpilot.identify(userInfo.customer_id.toString(), {
          name: userInfo.customer_name || userInfo.customerName,
          email: userInfo.email_log_in_id,
          country: userInfo.country_name || userInfo.countryName,
          userType: userInfo.internal_user_id ? 'internal' : 'client',
          internalUserId: userInfo.internal_user_id,
          userRoles: userInfo.user_roles,
          role: userInfo.role,
          clinicId: userInfo.clinic_id
        });
      }
    },
  }
}
</script>

<style>
.bootstrap-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-family: 'IBM Plex Sans Hebrew', sans-serif;
}

.loading-spinner {
  font-size: 18px;
  color: #004879;
}
</style>
